import { createContext } from 'react';

export enum PaymentProviders {
  STRIPE = 'stripe',
  PAYPAL = 'paypal',
  QUILLBOT = 'quillbot',
  CHARGEBEE_STRIPE = 'chargebee_stripe',
  CHARGEBEE_PAYPAL = 'chargebee_paypal',
  CHARGEBEE_GPAY = 'chargebee_gpay',
  INSTITUTE = 'institute',
  COMPANY = 'company',
  HIRING_CANDIDATES = 'hiring_candidates',
}

export interface PaymentAdditionalDetails {
  firstName?: string;
  lastName?: string;
  billingAddr1?: string;
  billingAddr2?: string;
  billingCity?: string;
  billingState?: string;
  billingStateCode?: string;
  billingZip?: string;
  billingCountry?: string;
}

interface Three3dsBillingDetails {
  firstName?: string;
  lastName?: string;
  phone?: string;
  addressLine1?: string;
  addressLine2?: string;
  addressLine3?: string;
  city?: string;
  state?: string;
  stateCode?: string;
  countryCode?: string;
  zip?: string;
}

export interface Three3dsPaymentInformation {
  element?: {};
  card?: {};
  tokenizer?: Function;
  cbToken?: string;
  additionalData?: {
    plan?: string;
    billingAddress?: Three3dsBillingDetails;
    customerBillingAddress?: Three3dsBillingDetails;
    shippingAddress?: Three3dsBillingDetails;
    email?: string;
    phone?: string;
    mandate?: {
      requireMandate: boolean;
      description: string;
    };
  };
}

export interface Chargebee3DSHandler {
  setPaymentIntent: (
    paymentIntent: any,
    options?: { stripe: any; braintree: any; adyen: any }
  ) => void;
  updatePaymentIntent: (
    paymentIntent: any,
    options?: { stripe: any; braintree: any; adyen: any }
  ) => void;
  handleCardPayment: (
    paymentInfo: Three3dsPaymentInformation,
    callbacks?: {
      change: Function;
      success: Function;
      error: Function;
    }
  ) => void;
}

export const offlinePaymentProviders: string[] = [
  PaymentProviders.QUILLBOT,
  PaymentProviders.INSTITUTE,
  PaymentProviders.COMPANY,
  PaymentProviders.HIRING_CANDIDATES,
];

export interface CardCheck {
  skipAdd?: boolean;
  abort?: boolean;
  token?: string;
  message?: string;
}

export const PaymentMethodsContext = createContext<Record<string, boolean>>({});
